module.exports = __webpack_public_path__ + "static/img/02.c82eb4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/02.png
// module id = 2p9i
// module chunks = 1